import React from "react";

import {
  LEAVE_TYPE_LABELS,
  LEAVE_STATUS_LABELS,
} from "../utils/staffHolidayConstants";
import { formatDisplayDate } from "../utils/staffHolidayDateUtils";
import {
  formatNumber,
  getRequestStaffName,
  getRequestStaffEmail,
} from "../utils/staffHolidayStaffUtils";
import "../../../css/StaffHoliday/StaffHolidayActionConfirmModal.css";

const StaffHolidayActionConfirmModal = ({
  open,
  title,
  description,
  request,
  confirmLabel,
  cancelLabel = "Go Back",
  tone = "primary",
  busy = false,
  reason = "",
  reasonLabel = "Reason",
  reasonPlaceholder = "Optional",
  showReason = false,
  onReasonChange,
  onConfirm,
  onClose,
}) => {
  if (!open || !request) return null;

  const staffName = getRequestStaffName(request);
  const staffEmail = getRequestStaffEmail(request);

  return (
    <div className="staff-holiday-popup-backdrop" role="presentation">
      <div
        className="staff-holiday-popup"
        role="dialog"
        aria-modal="true"
        aria-labelledby="staff-holiday-action-title"
      >
        <div className="staff-holiday-popup-header">
          <div>
            <p className="staff-holiday-eyebrow FP_Help_Text_Semibold">
              Staff Holiday
            </p>
            <div id="staff-holiday-action-title" className="FP_Subtitle">
              {title}
            </div>
            {description && (
              <p className="FP_Help_Text grey staff-holiday-popup-description">
                {description}
              </p>
            )}
          </div>

          <button
            type="button"
            className="staff-holiday-popup-close"
            onClick={onClose}
            disabled={busy}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="staff-holiday-popup-body">
          <div className="staff-holiday-popup-summary">
            <div>
              <span className="FP_Help_Text grey">Staff member</span>
              <strong className="FP_Content_Semibold black">{staffName}</strong>
              {staffEmail && (
                <span className="FP_Help_Text grey">{staffEmail}</span>
              )}
            </div>

            <div>
              <span className="FP_Help_Text grey">Leave type</span>
              <strong className="FP_Content_Semibold black">
                {LEAVE_TYPE_LABELS[request.leaveType] ||
                  request.leaveType ||
                  "-"}
              </strong>
            </div>

            <div>
              <span className="FP_Help_Text grey">Dates</span>
              <strong className="FP_Content_Semibold black">
                {formatDisplayDate(request.startDate)} to{" "}
                {formatDisplayDate(request.endDate)}
              </strong>
            </div>

            <div>
              <span className="FP_Help_Text grey">Total days</span>
              <strong className="FP_Content_Semibold black">
                {formatNumber(request.totalDays)}
              </strong>
            </div>

            <div>
              <span className="FP_Help_Text grey">Current status</span>
              <strong className="FP_Content_Semibold black">
                {LEAVE_STATUS_LABELS[request.status] || request.status || "-"}
              </strong>
            </div>

            <div>
              <span className="FP_Help_Text grey">Department</span>
              <strong className="FP_Content_Semibold black">
                {request.departmentName || "No department"}
              </strong>
            </div>
          </div>

          {showReason && (
            <label className="staff-holiday-popup-field">
              <span className="FP_Content_Semibold black">{reasonLabel}</span>
              <textarea
                value={reason}
                onChange={(event) => onReasonChange?.(event.target.value)}
                placeholder={reasonPlaceholder}
                rows={4}
                disabled={busy}
              />
            </label>
          )}
        </div>

        <div className="staff-holiday-popup-actions">
          <button
            type="button"
            className="staff-holiday-secondary-button"
            onClick={onClose}
            disabled={busy}
          >
            {cancelLabel}
          </button>

          <button
            type="button"
            className={
              tone === "danger"
                ? "staff-holiday-danger-button"
                : "staff-holiday-primary-button"
            }
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? "Processing..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StaffHolidayActionConfirmModal;
